import { render, staticRenderFns } from "./EmailConfirmation.vue?vue&type=template&id=436d4186&scoped=true"
import script from "./EmailConfirmation.vue?vue&type=script&lang=ts"
export * from "./EmailConfirmation.vue?vue&type=script&lang=ts"
import style0 from "./EmailConfirmation.vue?vue&type=style&index=0&id=436d4186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436d4186",
  null
  
)

export default component.exports